import * as React from 'react';

import { useDispatch } from "react-redux";

import { CheckSettingsForm } from "../Components/CheckSettings/CheckSettingsForm";
import { MetaMenu } from '../Components/MetaMenu/MetaMenu';
import { updateCheckSettingsAction } from "../Store/UserState";
import { ErrorWrapper } from '../Util/ErrorWrapper';

export const Settings = () => {
    const dispatch = useDispatch();
    return (
        <React.Fragment>
            <ErrorWrapper>
                <CheckSettingsForm onSubmit={(settings) => dispatch(updateCheckSettingsAction({settings}))}/>
            </ErrorWrapper>

            <MetaMenu />
        </React.Fragment>
    );
}
